// Note this is a subset of the Order Strategies that exist. The full set is driven by the backend.
export const OrderStrategiesEnum = {
  Limit: 'Limit',
  FullAmount: 'FullAmount',
  Pegged: 'Pegged',
  TWAP: 'TWAP',
  TimeSliced: 'TimeSliced',
  SteadyPace: 'SteadyPace',
  StopLimit: 'StopLimit',
  TakeProfitLimit: 'TakeProfitLimit',
  EnclaveCross: 'EnclaveCross',
  MultilegAggressiveLimit: 'MultilegAggressiveLimit',
  PostOnly: 'PostOnly',
  Iceberg: 'Iceberg',
  MultilegTWAP: 'MultilegTWAP',
  MarketTWAP: 'MarketTWAP',
  RefRatePegSteadyPace: 'RefRatePegSteadyPace',
  RefRatePegTimeSliced: 'RefRatePegTimeSliced',
  AggressivePeggedMarket: 'AggressivePeggedMarket',
  SteadyPaceStop: 'SteadyPaceStop',
  Market: 'Market',
  SteadyPaceRefRate: 'SteadyPaceRefRate',
  TWAPv1: 'TWAPv1',
  PegMid: 'PegMid',
  StopMarket: 'StopMarket',
  TakeProfitMarket: 'TakeProfitMarket',
  PercentOfVolume: 'PercentOfVolume',
  MultilegPassiveLimit: 'MultilegPassiveLimit',
  StopFullAmount: 'StopFullAmount',
  TakeProfitFullAmount: 'TakeProfitFullAmount',
  TWAPStopv2: 'TWAPStopv2',
  StopTWAP: 'StopTWAP',
  TakeProfitTWAP: 'TakeProfitTWAP',
  MultilegLimitV2: 'MultilegLimitV2',
  OpportunisticLimit: 'OpportunisticLimit',
  Quantizer: 'Quantizer',
  MarketQuantizer: 'MarketQuantizer',
} as const;
export type OrderStrategiesEnum = (typeof OrderStrategiesEnum)[keyof typeof OrderStrategiesEnum];

// Note this is a subset of the Parameter Keys that exist. The full set is driven by the backend.
export const ParameterKeysEnum = {
  PriceOffset: 'PriceOffset',
  PriceProtection: 'PriceProtection',
  UnifiedLiquidity: 'UnifiedLiquidity',
  ReduceOnly: 'ReduceOnly',
  ReduceFirst: 'ReduceFirst',
  ShowQty: 'ShowQty',
  Duration: 'Duration',
  EndTime: 'EndTime',
  StartTime: 'StartTime',
} as const;
export type ParameterKeysEnum = (typeof ParameterKeysEnum)[keyof typeof ParameterKeysEnum];

/**
 * Converts a ParameterKeysEnum value to camelCase for accessing OMSFormOrderParameters.
 *
 * OMSFormOrderParameters uses CamelCased<...> which converts PascalCase keys to camelCase,
 * so 'EndTime' becomes 'endTime', 'Duration' becomes 'duration', etc.
 *
 * Use this when accessing form.parameters properties with ParameterKeysEnum values.
 *
 * @example
 * const key = toOMSFormParamKey(ParameterKeysEnum.EndTime); // 'endTime'
 * if (parameters[key]) { ... }
 */
type CamelCase<S extends string> = S extends `${infer F}${infer R}` ? `${Lowercase<F>}${R}` : S;

export function toOMSFormParamKey<T extends ParameterKeysEnum>(key: T): CamelCase<T> {
  return (key.charAt(0).toLowerCase() + key.slice(1)) as CamelCase<T>;
}

export const DISABLED_REASONABILITY_CHECK_STRATEGIES: Set<string> = new Set<OrderStrategiesEnum>([
  OrderStrategiesEnum.Pegged,
  OrderStrategiesEnum.TWAP,
  OrderStrategiesEnum.SteadyPace,
  OrderStrategiesEnum.TimeSliced,
]);
